// src/components/client/LoyaltyPointsSelector.tsx
import React, { useState } from 'react';
import TeslaButton from '../common/TeslaButton';

interface LoyaltyPointsSelectorProps {
  availablePoints: number;
  pointsToRedeem: number;
  onPointsChange: (points: number) => void;
  onRedeem: () => void;
  isLoading: boolean;
  stylistName: string;
}

const LoyaltyPointsSelector: React.FC<LoyaltyPointsSelectorProps> = ({
  availablePoints,
  pointsToRedeem,
  onPointsChange,
  onRedeem,
  isLoading,
  stylistName
}) => {
  const [error, setError] = useState<string | null>(null);
  
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const points = parseInt(e.target.value);
    if (isNaN(points)) {
      onPointsChange(0);
      return;
    }
    
    if (points > availablePoints) {
      setError(`You only have ${availablePoints} points available with ${stylistName}`);
    } else {
      setError(null);
    }
    
    onPointsChange(points);
  };
  
  const handleRedeem = () => {
    if (pointsToRedeem <= 0) {
      setError('Please enter a valid number of points');
      return;
    }
    
    if (pointsToRedeem > availablePoints) {
      setError(`You only have ${availablePoints} points available with ${stylistName}`);
      return;
    }
    
    setError(null);
    onRedeem();
  };
  
  return (
    <div className="loyalty-points">
      <h3 className="loyalty-points__title">
        Redeem Loyalty Points
      </h3>
      
      <div className="loyalty-points__info">
        <svg className="loyalty-points__info-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="16" x2="12" y2="12"></line>
          <line x1="12" y1="8" x2="12.01" y2="8"></line>
        </svg>
        <p className="loyalty-points__info-text">
          You have {availablePoints} points available for this stylist.
          Each 100 points = $1 discount (max 25% of service price).
        </p>
      </div>
      
      <div className="loyalty-points__form">
        <div className="loyalty-points__input-wrapper">
          <label className="loyalty-points__label">
            Points to Redeem
          </label>
          <div className="loyalty-points__input-container">
            <input
              type="number"
              className={`loyalty-points__input ${error ? 'error' : ''}`}
              value={pointsToRedeem || ''}
              onChange={handleInputChange}
              placeholder="0"
            />
            <span className="loyalty-points__input-suffix">points</span>
          </div>
          {error && (
            <div className="loyalty-points__error">
              {error}
            </div>
          )}
        </div>
        
        <TeslaButton
          variant="primary"
          onClick={handleRedeem}
          disabled={isLoading || pointsToRedeem <= 0 || pointsToRedeem > availablePoints}
        >
          <div className="loyalty-points__button-content">
            {isLoading ? (
              <div className="loyalty-points__spinner"></div>
            ) : (
              <svg className="loyalty-points__button-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
              </svg>
            )}
            Redeem
          </div>
        </TeslaButton>
      </div>
    </div>
  );
};

export default LoyaltyPointsSelector;